import { render } from "./MenuItems.vue?vue&type=template&id=8504df1e&ts=true"
import script from "./MenuItems.vue?vue&type=script&lang=ts"
export * from "./MenuItems.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__